import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';

const useClaimedStakingRewards = () => {
    const { account } = useWeb3React();

    const { interfaceSDK } = useContext(appContext);

    const { data, error } = useSWR(
        interfaceSDK && account ? ['claimedStakingRewards', account] : null,
        (_, userAddress) => interfaceSDK!.get.getClaimedStakingRewards(userAddress!)
    );

    return {
        claimedStakingRewards: data,
        isLoading: !error && !data,
        error,
    };
};

export default useClaimedStakingRewards;
